import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import ErrorDataMessageConfig from './ErrorDataMessageConfig';
import ErrorStatusMessageConfig from './ErrorStatusMessageConfig';

var HttpErrorMessageConfig = /*#__PURE__*/function () {
  /**
   * @param {string} defaultMessage
   */
  function HttpErrorMessageConfig(defaultMessage) {
    _classCallCheck(this, HttpErrorMessageConfig);

    /**
     * @type {string}
     */
    this["default"] = defaultMessage;
    /**
     * @type {?string}
     */

    this.network = null;
    /**
     * @type {?function(ErrorResponse)}
     */

    this.custom = null;
    /**
     * @type {?ErrorDataMessageConfig}
     */

    this.errorData = null;
    /**
     * @type {?(string|function)}
     */

    this.tooManyRequests = null;
    /**
     * @type {?ErrorStatusMessageConfig}
     */

    this.status = null;
  }
  /**
   * @param {HttpErrorMessageConfig} messageConfig
   * @param {HttpErrorMessageConfig} sourceMessageConfig
   *
   * @return {HttpErrorMessageConfig}
   */


  _createClass(HttpErrorMessageConfig, [{
    key: "getDefault",
    value:
    /**
     * @returns {?string}
     */
    function getDefault() {
      return this["default"];
    }
    /**
     * @param {?string} value
     *
     * @returns {HttpErrorMessageConfig}
     */

  }, {
    key: "setDefault",
    value: function setDefault(value) {
      this["default"] = value;
      return this;
    }
    /**
     * @returns {?string}
     */

  }, {
    key: "getNetwork",
    value: function getNetwork() {
      return this.network;
    }
    /**
     * @param {?string} value
     *
     * @returns {HttpErrorMessageConfig}
     */

  }, {
    key: "setNetwork",
    value: function setNetwork(value) {
      this.network = value;
      return this;
    }
    /**
     * @returns {?function(ErrorResponse)}
     */

  }, {
    key: "getCustom",
    value: function getCustom() {
      return this.custom;
    }
    /**
     * @param {?function(ErrorResponse)} value
     *
     * @returns {HttpErrorMessageConfig}
     */

  }, {
    key: "setCustom",
    value: function setCustom(value) {
      this.custom = value;
      return this;
    }
    /**
     * @returns {?ErrorDataMessageConfig}
     */

  }, {
    key: "getErrorData",
    value: function getErrorData() {
      return this.errorData;
    }
    /**
     * @param {?ErrorDataMessageConfig} value
     *
     * @returns {HttpErrorMessageConfig}
     */

  }, {
    key: "setErrorData",
    value: function setErrorData(value) {
      this.errorData = value;
      return this;
    }
    /**
     * @returns {?(string|function)}
     */

  }, {
    key: "getTooManyRequests",
    value: function getTooManyRequests() {
      return this.tooManyRequests;
    }
    /**
     * @param {?(string|function)} value
     *
     * @returns {HttpErrorMessageConfig}
     */

  }, {
    key: "setTooManyRequests",
    value: function setTooManyRequests(value) {
      this.tooManyRequests = value;
      return this;
    }
    /**
     * @returns {?ErrorStatusMessageConfig}
     */

  }, {
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }
    /**
     * @param {?ErrorStatusMessageConfig} value
     *
     * @returns {HttpErrorMessageConfig}
     */

  }, {
    key: "setStatus",
    value: function setStatus(value) {
      this.status = value;
      return this;
    }
  }], [{
    key: "merge",
    value: function merge(messageConfig, sourceMessageConfig) {
      var mergedMessageConfig = new HttpErrorMessageConfig(messageConfig.getDefault() || sourceMessageConfig.getDefault());
      mergedMessageConfig.setNetwork(messageConfig.getNetwork() || sourceMessageConfig.getNetwork());
      mergedMessageConfig.setCustom(messageConfig.getCustom() || sourceMessageConfig.getCustom());
      mergedMessageConfig.setTooManyRequests(messageConfig.getTooManyRequests() || sourceMessageConfig.getTooManyRequests());

      if (sourceMessageConfig.getErrorData() !== null || messageConfig.getErrorData() !== null) {
        mergedMessageConfig.setErrorData(ErrorDataMessageConfig.merge(sourceMessageConfig.getErrorData() || new ErrorDataMessageConfig(), messageConfig.getErrorData() || new ErrorDataMessageConfig()));
      }

      if (sourceMessageConfig.getStatus() !== null || messageConfig.getStatus() !== null) {
        mergedMessageConfig.setStatus(ErrorStatusMessageConfig.merge(sourceMessageConfig.getStatus() || new ErrorStatusMessageConfig(), messageConfig.getStatus() || new ErrorStatusMessageConfig()));
      }

      return mergedMessageConfig;
    }
  }]);

  return HttpErrorMessageConfig;
}();

export { HttpErrorMessageConfig as default };